import { fetchWithHandling } from "../ApiUtils";
import { login } from "../login/UserLogin";

const URL = `${process.env.REACT_APP_API_URL}/api/member/settings`;
const target = "/member/settings";

/**
 * GET request to fetch saved member data and dropdown data
 */
export const getMemberSettingsData = async () => {
    return fetchWithHandling(URL, target, {
        method: "GET"
    });
}

/**
 * PUT request to save updated member data
 */
export const updateMemberSettingsData = async (data) => {
    const response = await fetch(`${URL}`, {
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include", // authentication cookie is sent with this
        method: 'PUT',
        body: JSON.stringify(data)
    });
    const responseBody = await response.json();
    return {
        ok: response.ok,
        status: response.status,
        updatedMember: responseBody
    };
}